//
// SearchControl form javascript
//
// Ben Ramey
// January 2009
//
HEIJS.SearchControl = function (form)
{
  this.form = form;

  if (this.form.length == 0)
    return;

  this.colwidths =
  {
    "Project #": 125,
    "Store #": 50,
    "City": 175,
    "ST": 30,
    "Phase Desc.": 130,
    "Scope of Work": 350,
    "SOW Status": 120,
    "Cumulative Scope of Work": 350,
    "Date": 105,
    "QC 1 Date": 105,
    "QC 2 Date": 105,
    "Refrig Tech QC": 105,
    "PM": 135,
    "Fixture Designer": 135,
    "Refrig Lead": 135,
    "Refrig Designer": 135,
    "Mech Designer": 135,
    "Elec Lead": 135,
    "Elec Designer": 135,
    "Fire Designer": 135,
    "Base Cleaned": 105,
    "Legend Coord": 105,
    "Legend Rqtd": 105,
    "Legend Rcvd": 105,
    "Struct Coord": 105,
    "Struct Rqtd": 105,
    "Struct Rcvd": 105,
    "Arch Coord": 105,
    "Arch Rqtd": 105,
    "Arch Rcvd": 105,
    "Fire Coord": 105,
    "Fire Rqtd": 105,
    "Fire Rcvd": 105,
    "Fixt QC 1": 135,
    "Fixt QC 2": 135,
    "Refrig QC 1": 135,
    "Refrig QC 2": 135,
    "Elec QC 1": 135,
    "Elec QC 2": 135,
    "EMS Vendor": 115,
    "Status": 50,
    "Shell Status": 120,
    "Shell Sent": 105,
    "Site Visit": 105,
    "Mech Scoper": 135,
    "Elec Scoper": 135,
    "Est Comp Date": 105,
    "Follow-up Date": 105,
    "Follow-up Mech": 135,
    "Follow-up Elec": 135,
    "USMV#": 120,
    "Store Tech": 135,
    "Regional Manager": 135,
    "Walmart PM": 135,
    "Construction Manager": 135,
    "Address": 135,
    "ZIP": 50
  };
  this.searchBtn = $(".search-criteriabuttons a[id*=Search], .action-buttons a[id*=Search]", this.form);
  this.clearBtn = $(".search-criteriabuttons a[id$=Clear], .action-buttons a[id$=Clear]", this.form);
  this.exportBtn = $(".search-criteriabuttons a[id$=Export], .action-buttons a[id$=Export]", this.form);
  this.searchInputs = $(".search-criteria", this.form).find("input,select");
  this.gridWrapper = $("div.search-gridholder", this.form);
  this.rowsPerPage = 0;

  this.rowClickIsDefaultAction = $("input[id$=RowClickIsDefaultActionInput]", this.form).val() != undefined
    ? $("input[id$=RowClickIsDefaultActionInput]", this.form).val().toLowerCase() == "true"
    : false;
  this.afterEditValueChanged = new HEIJS.Event();

  try
  {
    this.clientGridInstance = eval($("input[id$=ClientName]", this.form).attr("value"));

    if (typeof (this.clientGridInstance) !== "undefined")
    {
      this.clientGridInstance.SetFocusedRowIndex(-1);
      if (this.rowClickIsDefaultAction)
      {
        $(this.clientGridInstance.GetMainElement()).css("cursor", "pointer");
      }

      this.initializeRowsPerPageDiv();
      this.initializeVerticalScrollHeight();
	  this.initializeGridControlWidths();
    }
  }
  catch (err)
  {
    if (window.console)
    {
      console.log("Could not find grid client instance name: " + err);
    }
  }

  this.showCriteriaInPopup = $(".search-criteriapopup", this.form).length > 0;

  this.setupColgroup();
  this.initializeColumnChooser();
  this.noOverflowCols();
  this.setupChildColumns();
  this.initCriteriaControls();
  this.setupEvents();
  this.setupEditCapabilities();
  this.setupFixedColumns();
  
};

HEIJS.SearchControl.prototype =
{
  //
  // Properties
  //
  form: null,
  searchBtn: null,
  clearBtn: null,
  exportBtn: null,
  searchInputs: null,
  rowClickIsDefaultAction: null,
  gridWrapper: null,
  rowsPerPageDiv: null,
  rowsPerPage: null,
  showCriteriaInPopup: false,
  // editing fields
  currentEditingCell: null,
  typingTimer: null,
  // Events
  afterEditValueChanged: null,

  //
  // Methods
  //
  setupFixedColumns: function ()
  {
    if (!this.clientGridInstance)
      return;

    var lastFixedIndex = this.clientGridInstance.cpLastFixedColumnIndex;
    if (lastFixedIndex == null)
      return;

    var self = this;
    var mainTable = $(this.clientGridInstance.GetMainElement()).find("table[id$=DXMainTable]");
    var headerTable = $(this.clientGridInstance.GetMainElement()).find("table[id$=DXHeaderTable]");
    var mainTableDiv = mainTable.parent();

    if (lastFixedIndex < 0)
    {
      mainTableDiv.css("overflow-x", "auto");
      return;
    }

    var scrollColumnsWidth = 0;
    var scrollColumnWidths = {};
    var firstScrollIndex = lastFixedIndex + 1;
    $("tbody>tr:first>td:nth-child(" + firstScrollIndex + ")", mainTable).nextAll().each(function (i, d)
    {
      var outerWidth = $(this).outerWidth(true);
      scrollColumnsWidth += outerWidth;
      scrollColumnWidths[firstScrollIndex + i] = outerWidth;
    });

    var scrollDivWidth = this.clientGridInstance.GetWidth() - 2;
    var mainTableWidth = mainTable.width();
    var fixedColumnsWidth = mainTableWidth - scrollColumnsWidth;
    var doingScroll = false;
    var columns = [];
    var prevScrollLeft = 0;
    var prevLastHiddenIndex = firstScrollIndex;

    mainTableDiv
      .css("overflow-x", "hidden")
      .height(mainTableDiv.height() - 18)
      .after(
        $("<div class='horz-scroll-wrapper'></div>").css({
          height: "18px",
          width: scrollDivWidth,
          "overflow-x": "scroll",
          "overflow-y": "hidden"
        })
        .scroll(function (e)
        {
          if (doingScroll)
            return;

          doingScroll = true;
          var scrollLeft = $(this).scrollLeft();
          var lastHiddenIndex = firstScrollIndex;
          var hiddenColumnWidths = 0;
          while (hiddenColumnWidths < scrollLeft)
          {
            hiddenColumnWidths += scrollColumnWidths[lastHiddenIndex];
            lastHiddenIndex++;
          }

          var scrollingBackwards = prevScrollLeft > scrollLeft;
          if (scrollingBackwards)
          {
            for (var idx = prevLastHiddenIndex - 1; idx >= lastHiddenIndex; idx--)
            {
              columns[idx].filter(":not(.dxgv)").each(function (i)
              {
                $(columns[lastFixedIndex][i]).after(this);
                $(this).css("visibility", "visible");
              });
              columns[idx].filter(".dxgv").show();
            }
          }
          else
          {
            for (var idx = prevLastHiddenIndex; idx < lastHiddenIndex; idx++)
            {
              columns[idx].filter(":not(.dxgv)").each(function ()
              {
                $(this).css("visibility", "hidden").appendTo($(this).parent());
              });
              columns[idx].filter(".dxgv").hide();
            }
          }

          doingScroll = false;
          prevScrollLeft = scrollLeft;
          prevLastHiddenIndex = lastHiddenIndex;
        })
        .append($("<div>&nbsp;</div>").width(mainTableWidth))
      );

    $("div.horz-scroll-wrapper").one("mouseover", function ()
    {
      var headerCells = headerTable.children("tbody").children("[id*=DXHeadersRow]").children("td");
      var headerCols = headerTable.children("colgroup").children("col");
      var mainCells = mainTable.children("tbody").children("tr").children("td");
      var mainCols = mainTable.children("colgroup").children("col");
      var numCols = mainTable.children("tbody").children("tr:first").children("td").length;

      for (var col = 0; col < numCols; col++)
      {
        if (!columns[col])
          columns[col] = [];

        columns[col].push(headerCells[col]);
        columns[col].push(headerCols[col]);
        columns[col].push(mainCols[col]);
        mainCells.filter(":nth-child(" + (col + 1) + ")").each(function ()
        {
          columns[col].push(this);
        });
      }

      for (var col = 0; col < columns.length; col++)
      {
        columns[col] = $(columns[col]);
      }
    });
  },

  reinitFixedColumns: function ()
  {
    if (this.clientGridInstance.cpLastFixedColumnIndex == null || this.clientGridInstance.cpLastFixedColumnIndex < 0)
      return;

    $("div.horz-scroll-wrapper").remove();
    var mainTableDiv = $(this.clientGridInstance.GetMainElement()).find("table[id$=DXMainTable]").parent();
    mainTableDiv.height(mainTableDiv.height() + 18);

    this.setupFixedColumns();
  },

  //
  // Setup methods for different edit column types
  //
  noOverflowCols: function ()
  {
    var self = this;
    var noOverflowDivs = $("div.searchcontrol-nooverflowcol", this.form);
    noOverflowDivs.hover(
      function ()
      {
        var icon = $("<span class='ui-icon ui-icon-newwin' title='Click to see entire column contents'></span>");
        $(this).append(icon);
        icon.click(function (e)
        {
          e.preventDefault();
          var dialog = $(this).parent().clone();
          dialog.dialog({ title: 'Column Details', close: function () { $(this).remove(); } }).find("span.ui-icon").remove();
          $(this).remove();
          self.processWBS1s(dialog);
        });
      },
      function () { $(this).find("span.ui-icon").remove(); }
    );
  },

  setupColgroup: function ()
  {
    var self = this;

    if (!self.clientGridInstance || !self.clientGridInstance.name.toLowerCase().match("schedulinggrid"))
    {
      return;
    }

    var mainTable = $(self.clientGridInstance.GetMainElement()).find("table[id$=DXMainTable]");
    var headerTable = $(self.clientGridInstance.GetMainElement()).find("table[id$=DXHeaderTable]");

    var colgrouptxt = '<colgroup>';

    headerTable.children("tbody").children("[id*=DXHeadersRow]").children().each(function (index)
    {
      var tmpwidth = self.colwidths[$.trim($(this).text())];

      if (tmpwidth == undefined)
      {
        tmpwidth = 45;
      }

      colgrouptxt += '<col style="width:' + (tmpwidth) + 'px;" />';
    });

    colgrouptxt += '</colgroup>';

    headerTable.children("colgroup").remove();
    mainTable.children("colgroup").remove();
    headerTable.prepend(colgrouptxt);
    mainTable.prepend(colgrouptxt);
  },

  setupChildColumns: function ()
  {
    var moreLinks = $("a.childcolumn-morelink", this.form);
    var self = this;
    moreLinks.click(function (e)
    {
      e.preventDefault();
      e.stopPropagation();
      var div = $("<div>").dialog({ title: "More items", close: function () { $(this).remove(); } });
      $(this).siblings().clone().show().appendTo(div);
      self.processWBS1s(div);
    });
  },

  processWBS1s: function (element)
  {
    if (typeof (HEIJS.page.ProjectActions) != "undefined")
    {
      HEIJS.page.ProjectActions.processNonSpannedWBS1s(element);
      var projectSpans = element.find("span.wbs1");
      projectSpans.each(function () { HEIJS.page.ProjectActions.validWBS1($(this)); });
      HEIJS.page.ProjectActions.setupProjectSpans(projectSpans);
      HEIJS.page.ProjectActions.setupEvents(projectSpans);
    }
  },

  setupBoolEditCapabilities: function ()
  {
  },

  setupDateTimeEditCapabilities: function ()
  {
    var self = this;
    $("span.searchcontrol-dateeditforcolumn", this.form)
      .children("input[type='text']")
      .unbind("change keyup paste")
      .bind("change keyup paste", function (e) { self.handleDateEditValueChanged($(this), e); });
  },

  setupTextEditCapabilities: function ()
  {
    var self = this;
    $("span.searchcontrol-texteditcell", this.form)
      .siblings("input[type='text']")
      .unbind("change keyup paste")
      .bind("change keyup paste", function (e) { self.handleTextEditValueChanged($(this), e); });
  },

  setupTextAreaEditCapabilities: function ()
  {
    var self = this;
    $("span.searchcontrol-textareaeditcell", this.form)
      .siblings("textarea")
      .unbind("change keyup paste")
      .bind("change keyup paste", function (e) { self.handleTextAreaEditValueChanged($(this), e); });
  },

  setupLookupEditCapabilities: function ()
  {
    var self = this;
    $("select.searchcontrol-lookupeditforcolumn", this.form).each(
      function ()
      {
        $(this)
          .unbind("change")
          .bind("change", function () { self.handleLookupEditValueChanged($(this)); });
      }
    );
  },

  targetIsEditCell: function (e)
  {
    // this works in IE
    var target = $(e.htmlEvent.srcElement);

    // this works in FF
    if (target.length <= 0)
      target = $(e.htmlEvent.target);

    var cell = null;
    if (target.is("td.searchcontrol-editcell"))
      cell = target;
    else if (target.parents("td.searchcontrol-editcell").length > 0)
      cell = target.parents("td.searchcontrol-editcell");

    return cell;
  },

  setupEditCapabilities: function ()
  {
    if (!this.clientGridInstance)
      return;

    var self = this;
    var mainTable = $(this.clientGridInstance.GetMainElement()).find("table[id$=DXMainTable]")
    $("tbody>tr", mainTable).one("mouseover", function ()
    {
      $("span.searchcontrol-editcell", $(this))
		  .each(function () { $(this).parent("td").addClass($(this).attr("class")); })
		  .parents("td.searchcontrol-editcell")
			.unbind("hover")
			.hover(
			  function ()
			  {
			    if (self.currentEditingCell == null || $(this).attr("id") != self.currentEditingCell.attr("id"))
			      $(this).prepend('<span class="ui-icon ui-icon-pencil"></span>');
			  },
			  function () { $(this).children("span.ui-icon-pencil").remove(); }
			);
    });

    $(document)
      .keydown(function (e) { self.handleEditCellInputKeyDown(self.currentEditingCell, e); })
      .click(function (e) { self.handleDocumentClick(e); });

    this.setupDateTimeEditCapabilities();
    this.setupLookupEditCapabilities();
    this.setupTextEditCapabilities();
    this.setupTextAreaEditCapabilities();
    this.setupBoolEditCapabilities();
  },

  //
  // edit event handlers
  //
  handleEditCellClick: function (cell, e)
  {
    if ($.browser.msie)
    {
      window.event.cancelBubble = true;
    }
    else
    {
      e.htmlEvent.stopPropagation()
    }

    if (this.currentEditingCell != null && cell.attr("id") == this.currentEditingCell.attr("id"))
      return;

    this.stopCellEdit(this.currentEditingCell);
    this.startCellEdit(cell);

    this.currentEditingCell = cell;
  },

  startCellEdit: function (cell)
  {
    if (cell == null)
      return;

    var self = this;
    cell.children("span.ui-icon-pencil").remove();

    if (cell.is(".searchcontrol-dateeditcell"))
    {
      var dateEditForColumnControl = $("span.searchcontrol-dateeditforcolumn", this.form);
      var dateTextBox = dateEditForColumnControl.find("input[type='text']");
      var span = cell.children("span.searchcontrol-dateeditcell");

      dateTextBox.val(span.html() == "&nbsp;" ? "" : span.html());
      dateEditForColumnControl.show();

      span.hide();
      dateEditForColumnControl.appendTo(cell);
      dateTextBox.focus();
    }
    else if (cell.is(".searchcontrol-texteditcell"))
    {
      var span = cell.children("span.searchcontrol-texteditcell", this.form);
      var textBox = cell.children("input[type='text']");

      textBox.val(span.html() == "&nbsp;" ? "" : span.html());

      span.hide();
      textBox.show();
      textBox.focus();
    }
    else if (cell.is(".searchcontrol-booleditcell"))
    {
      var span = cell.children("span.searchcontrol-booleditcell", this.form);
      var checkBoxOrSelect = $("<input type='checkbox'/>");

      if (span.attr("isDropDown") == "True")
      {
        checkBoxOrSelect = $("<select>")
          .append($("<option>").text(span.attr("trueDisplay")))
          .append($("<option>").text(span.attr("falseDisplay")));
      }
      checkBoxOrSelect.appendTo(cell);

      var self = this;
      checkBoxOrSelect.bind("change", function () { self.handleBoolEditValueChanged($(this)); });

      if (checkBoxOrSelect.is("select"))
        checkBoxOrSelect.val(span.text());
      else
        checkBoxOrSelect.attr("checked", span.html() == "True" ? "checked" : "");

      span.hide();
      checkBoxOrSelect.show();
      checkBoxOrSelect.focus();
    }
    else if (cell.is(".searchcontrol-textareaeditcell"))
    {
      var span = cell.children("span.searchcontrol-textareaeditcell", this.form);
      var textArea = cell.children("textarea");

      textArea.val(span.html() == "&nbsp;" ? "" : span.html());

      span.hide();
      textArea.show();
      textArea.height(textArea.parent().innerHeight());
      textArea.focus();
    }
    else if (cell.is(".searchcontrol-lookupeditcell"))
    {
      var span = cell.children("span.searchcontrol-lookupeditcell");
      var roleDropDown = $("select.searchcontrol-lookupeditforcolumn[id$='" + span.attr("editField") + "LookupEditDropDown']", this.form);

      span.val(span.html() == "&nbsp;" ? "" : span.html());

      if (span.html() != "&nbsp;")
        roleDropDown.val(roleDropDown.children("option").filter(function () { return $(this).text() == span.html(); }).val());
      roleDropDown.show();

      span.hide();
      roleDropDown.appendTo(cell);
      roleDropDown.focus();
    }
  },

  stopCellEdit: function (cell)
  {
    if (cell == null)
      return;

    if (this.typingTimer > 0)
    {
      clearTimeout(this.typingTimer);
      this.typingTimer = 0;
      cell.find(":input").change();
    }

    if (cell.is(".searchcontrol-dateeditcell"))
    {
      var datePattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
      var span = cell.children("span.searchcontrol-dateeditcell");

      $("span.searchcontrol-dateeditforcolumn", this.form).hide().appendTo($("div.search-gridholder", this.form));
      span.show();

      if (span.html() != "&nbsp;" && span.html().search(datePattern) == -1)
      {
        alert("Invalid date value");
        span.html("&nbsp;");
      }
    }
    else if (cell.is(".searchcontrol-texteditcell"))
    {
      var span = cell.children("span.searchcontrol-texteditcell");
      var textBox = span.siblings("input[type='text']");

      span.show();
      textBox.hide();
    }
    else if (cell.is(".searchcontrol-booleditcell"))
    {
      var span = cell.children("span.searchcontrol-booleditcell");
      var checkBoxOrSelect = span.siblings("select,input[type='checkbox']");

      checkBoxOrSelect.remove();
      span.show();
    }
    else if (cell.is(".searchcontrol-textareaeditcell"))
    {
      var span = cell.children("span.searchcontrol-textareaeditcell");
      var textArea = span.siblings("textarea");

      span.show();
      textArea.hide();
    }
    else if (cell.is(".searchcontrol-lookupeditcell"))
    {
      var span = cell.children("span.searchcontrol-lookupeditcell");
      //Edited by Anu Panikulam Feb 2012 to avoid dropdowns defaulting to previous selected option

      var dropdownsR = $("select.searchcontrol-lookupeditforcolumn option[value='R']", this.form).parents('select');
      var dropdowns1 = $("select.searchcontrol-lookupeditforcolumn option[value=-1]", this.form).parents('select');

      dropdownsR.hide().appendTo($("div.search-gridholder", this.form)).val("R");
      dropdowns1.hide().appendTo($("div.search-gridholder", this.form)).val(-1);
	  
	  //to take care of anything left...
	  cell.find('select').hide().appendTo($("div.search-gridholder", this.form));
	  
      span.show();
    }
  },

  handleDocumentClick: function (e)
  {
    if (!this.currentEditingCell)
    {
      return;
    }

	$target = $(e.target);
	$lastParent = $target.parents().last();
    if (($target.parents("div#ui-datepicker-div").length > 0 || ($lastParent.attr('class') && $lastParent.attr('class').indexOf('datepicker') >= 0)) && this.currentEditingCell.is(".searchcontrol-dateeditcell"))
    {
      return;
    }

    this.stopCellEdit(this.currentEditingCell);
    this.currentEditingCell = null;
  },

  handleEditCellInputKeyDown: function (cell, e)
  {
    if (cell == null)
      return;

    var keyCode = e.which || e.keyCode;
    if (keyCode == 13) // return
    {
      e.preventDefault();

      var cellNum = cell.prevAll("td").length + 1;
      var nextOrPrevRowCell = e.shiftKey
        ? cell.parent("tr").prev("tr").children("td:nth-child(" + cellNum + ")")
        : cell.parent("tr").next("tr").children("td:nth-child(" + cellNum + ")");

      if (nextOrPrevRowCell.length > 0)
        this.handleEditCellClick(nextOrPrevRowCell, null);
    }
    else if (keyCode == 9) // tab
    {
      e.preventDefault();

      var nextOrPrevEditableCell = e.shiftKey
        ? cell.prev("td.searchcontrol-editcell")
        : cell.next("td.searchcontrol-editcell");

      if (nextOrPrevEditableCell.length > 0)
        this.handleEditCellClick(nextOrPrevEditableCell, null);
    }
  },

  //
  // Edit value change handlers
  //
  handleBoolEditValueChanged: function (checkBoxOrSelect)
  {
    var newValue = saveValue = null;
    var span = checkBoxOrSelect.parents("td.searchcontrol-booleditcell").children("span.searchcontrol-booleditcell");
    var rowIndex = this.clientGridInstance.GetFocusedRowIndex();

    if (checkBoxOrSelect.is("select"))
    {
      newValue = checkBoxOrSelect.children("option:selected").text();
      if (newValue == span.attr("trueDisplay"))
        saveValue = "True";
      else
        saveValue = "False";
    }
    else
    {
      saveValue = newValue = checkBoxOrSelect.is(":checked") ? "True" : "False";
    }

    this.afterEditValueChanged.Trigger(
      {
        PrimaryKey: this.clientGridInstance.GetRowKey(rowIndex),
        Value: saveValue,
        Field: span.attr("editField"),
        Cell: checkBoxOrSelect.parents("td.searchcontrol-lookupeditcell")
      });

    span.html(newValue);
  },

  handleTextEditValueChanged: function (textBox, e, dontDoTimeout)
  {
    if (e.type == "keyup")
    {
      var keyCode = e.which || e.keyCode;
      if (keyCode == 9 || keyCode == 13)
        return;
    }

    dontDoTimeout = dontDoTimeout || false;
    clearTimeout(this.typingTimer);
    this.typingTimer = 0;

    if (!dontDoTimeout && e.type == "keyup")
    {
      var self = this;
      this.typingTimer = setTimeout(function () { self.handleTextEditValueChanged(textBox, e, true); }, 300);
      return;
    }

    var newValue = textBox.val() == "" ? "&nbsp;" : textBox.val();
    var span = textBox.parents("td.searchcontrol-texteditcell").children("span.searchcontrol-texteditcell");
    var rowIndex = this.clientGridInstance.GetFocusedRowIndex();

    if (typeof (clipboardData) != "undefined" && e != null && e.type == "paste")
    {
      newValue = clipboardData.getData("text");
      textBox.val(newValue);
    }

    this.afterEditValueChanged.Trigger(
      {
        PrimaryKey: this.clientGridInstance.GetRowKey(rowIndex),
        Value: textBox.val(),
        Field: span.attr("editField"),
        Cell: textBox.parents("td.searchcontrol-texteditcell")
      });

    span.html(newValue);
  },

  handleTextAreaEditValueChanged: function (textArea, e, dontDoTimeout)
  {
    if (e.type == "keyup")
    {
      var keyCode = e.which || e.keyCode;
      if (keyCode == 9 || keyCode == 13)
        return;
    }

    dontDoTimeout = dontDoTimeout || false;
    clearTimeout(this.typingTimer);
    this.typingTimer = 0;

    if (!dontDoTimeout && e.type == "keyup")
    {
      var self = this;
      this.typingTimer = setTimeout(function () { self.handleTextAreaEditValueChanged(textArea, e, true); }, 300);
      return;
    }

    var newValue = textArea.val() == "" ? "&nbsp;" : textArea.val();
    var span = textArea.parents("td.searchcontrol-textareaeditcell").children("span.searchcontrol-textareaeditcell");
    var rowIndex = this.clientGridInstance.GetFocusedRowIndex();

    if (typeof (clipboardData) != "undefined" && e != null && e.type == "paste")
    {
      newValue = clipboardData.getData("text");
      textArea.val(newValue);
    }

    this.afterEditValueChanged.Trigger(
      {
        PrimaryKey: this.clientGridInstance.GetRowKey(rowIndex),
        Value: textArea.val(),
        Field: span.attr("editField"),
        Cell: textArea.parents("td.searchcontrol-textareaeditcell")
      });

    span.html(newValue);
  },

  handleLookupEditValueChanged: function (dropdown)
  {
    var newValue = dropdown.children("option:selected").text() == "" ? "&nbsp;" : dropdown.children("option:selected").text();
    var span = dropdown.parents("td.searchcontrol-lookupeditcell").children("span.searchcontrol-lookupeditcell");
    var rowIndex = this.clientGridInstance.GetFocusedRowIndex();

    this.afterEditValueChanged.Trigger(
      {
        PrimaryKey: this.clientGridInstance.GetRowKey(rowIndex),
        Value: dropdown.children("option:selected").val(),
        Field: span.attr("editField"),
        Cell: dropdown.parents("td.searchcontrol-lookupeditcell")
      });

    span.html(newValue);
  },

  handleDateEditValueChanged: function (dateTextBox, e, dontDoTimeout)
  {
    if (e.type == "keyup")
    {
      var keyCode = e.which || e.keyCode;
      if (keyCode == 9 || keyCode == 13)
        return;
    }

    dontDoTimeout = dontDoTimeout || false;
    clearTimeout(this.typingTimer);
    this.typingTimer = 0;

    if (!dontDoTimeout && e.type == "keyup")
    {
      var self = this;
      this.typingTimer = setTimeout(function () { self.handleDateEditValueChanged(dateTextBox, e, true); }, 300);
      return;
    }

    var newValue = dateTextBox.val() == "" ? "&nbsp;" : dateTextBox.val();
    var span = dateTextBox.parents("td.searchcontrol-dateeditcell").children("span.searchcontrol-dateeditcell");
    var rowIndex = this.clientGridInstance.GetFocusedRowIndex();

    if (typeof (clipboardData) != "undefined" && e != null && e.type == "paste")
    {
      newValue = clipboardData.getData("text");
      dateTextBox.val(newValue);
    }

    this.afterEditValueChanged.Trigger(
      {
        PrimaryKey: this.clientGridInstance.GetRowKey(rowIndex),
        Value: dateTextBox.val(),
        Field: span.attr("editField"),
        Cell: dateTextBox.parents("td.searchcontrol-dateeditcell")
      });

    span.html(newValue);
  },

  //
  // Initialization methods
  //
  initializeRowsPerPageDiv: function ()
  {
    this.rowsPerPageDiv = $("div.search-rowsperpage", this.form);

    if (this.clientGridInstance.cpPagingEnabled == "true")
    {
      this.rowsPerPageDiv.children("input").constrain({ allow: { regex: "[0-9]"} });
      this.rowsPerPage = this.rowsPerPageDiv.children("input").val();
      this.rowsPerPageDiv.children("input")
        .bind("change", this, function (e) { e.data.handleRowsPerPageChange($(this)); });
    }
  },

  initializeColumnChooser: function ()
  {
    var self = this;
    $("div.search-columnchooser-popup a[id$=SaveColumnsBtn]", this.form).click(function (e)
    {
      e.preventDefault();
      var hiddenColumns = [];
      $("div.search-columnchooser-popup", self.form).find("li:has(input:not(:checked))").each(function ()
      {
        hiddenColumns.push($(this).find("label").text());
      });

      self.clientGridInstance.PerformCallback("userhiddengridcolumns|" + hiddenColumns.join(","));
    });
  },

  initializeVerticalScrollHeight: function ()
  {
    if (this.clientGridInstance.cpAutoCalculateVerticalScrollHeight == "true")
    {
      var self = this;
      $(window).bind('resize.searchcontrol-vertical', function () { self.resizeVerticalScrollDiv(); });
      this.resizeVerticalScrollDiv();
    }
  },
  
  initializeGridControlWidths: function ()
  {
	  var self = this;
	  $(window).bind('resize.searchcontrol-grid', function () {
			clearTimeout($.data(this, 'resizeTimer'));
			$.data(this, 'resizeTimer', setTimeout(function() {
				self.resizeGridWidths();
			}, 100));
	  });
	  this.resizeGridWidths();
  },

  initCriteriaControls: function (parentElement)
  {
    if (this.showCriteriaInPopup && !parentElement)
      return;

    parentElement = parentElement || this.form;
    if (parentElement.find("input.date-picker").length > 0)
    {
      new HEIJS.SearchControl.DateTimeControls(parentElement);
    }

    if (parentElement.find("input.keywordcriteria-textbox").length > 0 && this.clientGridInstance)
    {
      var kwCrit = new HEIJS.SearchControl.KeywordCriteria(parentElement);
      this.clientGridInstance.EndCallback.AddHandler(function () { kwCrit.init(); });
    }
  },

  //
  // Basic search control event handlers
  //
  handleClientGridEndCallback: function (s, e)
  {
    this.setupColgroup();
    this.initializeColumnChooser();
    this.initializeRowsPerPageDiv();
    this.setupEditCapabilities();
    this.reinitFixedColumns();

    if (this.clientGridInstance.cpAutoCalculateVerticalScrollHeight == "true")
      this.resizeVerticalScrollDiv();

    if (typeof (HEIJS.page.ProjectActions) != "undefined")
    {
      var mainElement = $(this.clientGridInstance.GetMainElement());
      HEIJS.page.ProjectActions.processNonSpannedWBS1s(mainElement);

      var projectSpans = mainElement.find("span.wbs1");
      projectSpans.each(function () { HEIJS.page.ProjectActions.validWBS1($(this)); });
      HEIJS.page.ProjectActions.setupProjectSpans(projectSpans);
      HEIJS.page.ProjectActions.setupEvents(projectSpans);
    }
  },

  resizeVerticalScrollDiv: function ()
  {
    if (!this.clientGridInstance || this.clientGridInstance.cpAutoCalculateVerticalScrollHeight != "true") return;
	
	var mainElement = $(this.clientGridInstance.GetMainElement());
    var scrollDiv = mainElement.find("table[id$=DXMainTable]").parent();
    var tableFooterHeight = 0;
    scrollDiv.nextAll("table:visible,div:visible").each(function () { tableFooterHeight += $(this).outerHeight(); });
    HEIJS.controls.resizeControls(scrollDiv, tableFooterHeight);

    return;
  },
  
  resizeGridWidths: function ()
  {
	if (!this.clientGridInstance) return;
	
	var mainElement = $(this.clientGridInstance.GetMainElement());
    //var scrollDiv = mainElement.find("table[id$=DXMainTable]").parent();
	
	
	var w = mainElement.parent().width();
	$('div.horz-scroll-wrapper', mainElement).width(w);
	this.clientGridInstance.SetWidth(50);
	this.clientGridInstance.AdjustControl();
	this.clientGridInstance.SetWidth(w);
    this.clientGridInstance.AdjustControl();
  },

  handleRowsPerPageChange: function (textBox)
  {
    if (textBox.val() > 200)
    {
      if (!confirm("Loading over 200 rows may take a while.  Are you sure you want to proceed?"))
      {
        textBox.val(this.rowsPerPage);
        return;
      }
    }
    else if (textBox.val() <= 0)
    {
      alert("You must have at least one row per page.");

      textBox.val(this.rowsPerPage);
      return;
    }

    var text = " rows per page.";
    if (textBox.val() == 1)
    {
      text = text.replace(/rows/, "row");
    }
    textBox.next("span").text(text);

    this.rowsPerPage = textBox.val();
    this.clientGridInstance.PerformCallback("rowsperpage|" + textBox.val());
  },

  handleCriteriaInputKeyPress: function (keycode)
  {
    if (keycode == 13)
    {
      HEIJS.page.systemStatus.show("Searching");
      eval($(this.searchBtn).attr("href"));
    }
  },

  clearCriteriaInputs: function ()
  {
    this.searchInputs.each(
      function (idx, domElement)
      {
        var input = $(domElement);

        if (input.is("select"))
        {
          var prevVal = input.val();

          if (input.find("option[value=-1]").length > 0)
            input.val("-1");
          else
            input.val("");

          if (prevVal != input.val())
            input.change();
        }
        else if (input.is("input[type=checkbox]")
                || input.is("input[type=radio]"))
        {
          input.attr("checked", false);
        }
        else if (input.is("input[type=text]"))
        {
          input.val("");
        }
        // for devexpress date controls and their hidden inputs
        else if (input.is("input[type=hidden]")
                  && input.parents(".dateinput").length > 0)
        {
          if (input.prev().is("table.dxeButtonEdit"))
            input.val("0:0:-1:0:0:0:0:0:");
          else
            input.val("N");
        }
      }
    );
  },

  handleRowClick: function (sender, e)
  {
    var cell = this.targetIsEditCell(e);
    if (cell)
    {
      this.handleEditCellClick(cell, e);
      return;
    }

    if (!this.rowClickIsDefaultAction)
      return;

    // this works in IE
    var row = $(e.htmlEvent.srcElement).parents("tr:first");

    // this works in FF
    if (row.length <= 0)
      row = $(e.htmlEvent.target).parents("tr:first");

    if (row.length > 0)
    {
      var actionLink = row.find("a.grid-default-action:first");

      if (actionLink.length > 0)
      {
        if (actionLink.attr("target") == "_blank")
        {
          window.open(actionLink.attr("href"), "_blank");
        }
        else
        {
          HEIJS.page.systemStatus.show("Loading");
          document.location.href = actionLink.attr("href");
        }
      }
    }
  },

  toggleSearchCriteriaCollapse: function (button)
  {
    var collapseIcon = button.children(".ui-icon");
    var critBox = button.parent();
    if (critBox.height() == 10)
    {
      critBox.css("height", "auto");
      critBox.children().not(button).show();
      collapseIcon.addClass("ui-icon-triangle-1-n").removeClass("ui-icon-triangle-1-s");
      this.resizeVerticalScrollDiv();
    }
    else
    {
      critBox.css("height", "10px");
      critBox.children().not(button).hide();
      collapseIcon.addClass("ui-icon-triangle-1-s").removeClass("ui-icon-triangle-1-n");
      this.resizeVerticalScrollDiv();
    }
  },

  handleClearButtonClick: function ()
  {
    if (confirm("Really clear all search criteria?"))
      this.clearCriteriaInputs();
  },

  showSearchPopup: function ()
  {
    var self = this;
    var dialog = $(".search-criteriapopup", this.form)
      .clone()
      .removeClass("search-criteriapopup")
      .dialog({
        title: "Search Criteria",
        width: 600,
        autoOpen: true,
        buttons: {
          "Search": function ()
          {
            $(this).find(":input").each(function ()
            {
              var name = $(this).attr("name").replace("_popup", "");
              var id = $(this).attr("id").replace("_popup", "");
              $(this).attr("name", name);
              $(this).attr("id", id);

              $(".search-criteria [name='" + $(this).attr("name") + "']", self.form).replaceWith(this);
            });

            $(this).dialog("destroy").remove();
            HEIJS.page.systemStatus.show(self.searchBtn.attr("statusmessage"));
            eval($(self.searchBtn).attr("href"));
          },
          "Clear": function () { self.handleClearButtonClick(); },
          "Cancel": function () { $(this).dialog("destroy").remove(); }
        }
      });

    dialog.find(":input").each(function ()
    {
      var name = $(this).attr("name") + "_popup";
      var id = $(this).attr("id") + "_popup";
      $(this).attr("name", name);
      $(this).attr("id", id);
    });
    dialog.find("label").each(function () { $(this).attr("for", $(this).attr("for") + "_popup") });

    this.searchInputs = dialog.find("input,select");
    this.initCriteriaControls(dialog);
  },

  //
  // sets up initial events for search grid
  //
  setupEvents: function ()
  {
    var self = this;

    // criteria events
    this.clearBtn.click(function (e) { e.preventDefault(); self.handleClearButtonClick(); });
    this.searchInputs.keypress(function (e) { self.handleCriteriaInputKeyPress(e.which); });

    $("div.search-criteria div.search-criteria-collapse-btn")
      .click(function () { self.toggleSearchCriteriaCollapse($(this)); });

    if (this.showCriteriaInPopup)
    {
      this.searchBtn.click(function (e) { e.preventDefault(); self.showSearchPopup(); });
    }

    // devexpress callback events
    if (typeof (this.clientGridInstance) !== "undefined")
    {
      this.clientGridInstance.EndCallback.AddHandler(function (s, e) { self.handleClientGridEndCallback(s, e); });
      this.clientGridInstance.RowClick.AddHandler(function (sender, e) { self.handleRowClick(sender, e); });
    }
  }
};

$(document).ready(function ()
{
  if ($("div.searchpanel").length == 0)
    return;

  $("div.searchpanel").each(function ()
  {
    HEIJS.SearchControl.form = new HEIJS.SearchControl($(this));
  });

  if (typeof (window.__oldDoPostBack) == "undefined")
  {
    window.__oldDoPostBack = window.__doPostBack;
    window.__doPostBack = function (eventTarget, eventArgument)
    {
      if (typeof (_spFormOnSubmitCalled) != "undefined" && _spFormOnSubmitCalled)
        _spFormOnSubmitCalled = false;

      window.__oldDoPostBack(eventTarget, eventArgument);
    }
  }
});
